package br.com.htms.inspeccaocampo.platform

/** Gerenciador de senhas do navegador (só na Web; nas outras plataformas não faz nada). */
expect object CredenciaisNavegador {
    /** Usuário e senha que o navegador guardou para este site, ou null. */
    suspend fun obter(): Pair<String, String>?

    /** Oferece ao navegador guardar o login (chamar só depois de entrar com sucesso). */
    fun salvar(usuario: String, senha: String)

    /** Texto pequeno guardado no aparelho, disponível já na abertura da tela de login. */
    fun lerLocal(chave: String): String?

    fun gravarLocal(chave: String, valor: String?)
}

/** Usuários que já entraram neste aparelho (só o login, nunca a senha); o mais recente primeiro. */
object UsuariosLembrados {
    private const val CHAVE = "icd_usuarios_lembrados"
    private const val MAX = 8

    fun lista(): List<String> =
        runCatching { CredenciaisNavegador.lerLocal(CHAVE) }.getOrNull().orEmpty()
            .lines().map { it.trim() }.filter { it.isNotEmpty() }.distinctBy { it.lowercase() }

    fun lembrar(usuario: String) {
        val u = usuario.trim()
        if (u.isEmpty()) return
        gravar(listOf(u) + lista().filterNot { it.equals(u, ignoreCase = true) })
    }

    fun esquecer(usuario: String) {
        gravar(lista().filterNot { it.equals(usuario.trim(), ignoreCase = true) })
    }

    private fun gravar(l: List<String>) {
        runCatching { CredenciaisNavegador.gravarLocal(CHAVE, l.take(MAX).joinToString("\n").ifEmpty { null }) }
    }
}
